import {
  type PaletteMode,
  createTheme,
} from '@mui/material/styles';

export const createBrandTheme = (
  brandColors: { primary: string; secondary: string },
  mode: PaletteMode
) => {
  const isDark = mode === 'dark';
  const baseTheme = createTheme({ palette: { mode } });

  return createTheme(baseTheme, {
    palette: {
      primary: baseTheme.palette.augmentColor({
        color: { main: brandColors.primary },
        name: 'primary',
      }),
      secondary: baseTheme.palette.augmentColor({
        color: { main: brandColors.secondary },
        name: 'secondary',
      }),
      ...(!isDark && {
        background: {
          default: '#f5f5f5',
        },
      }),
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      button: {
        fontSize: '1rem',
        fontWeight: 600,
      },
    },
    shape: {
      borderRadius: 8,
    },
  });
};
